import { container } from '../../utils/container/container';
import { FeatureFlagsLoader } from '../../utils/feature-flags/feature-flags-loader';
import { ServiceIds } from '../../utils/container/service-ids';
import { FlagNames } from '../../utils/feature-flags/flag-names';

type PreloaderPercentsLayout = {
    initialPercent: number,
    compilingEndPercent: number,
    clientLoadingStart: number,
    clientLoadingEnd: number
}

export const PRELOADER_PERCENTS_REAL: PreloaderPercentsLayout = {
    initialPercent: 0,
    compilingEndPercent: 20,
    clientLoadingStart: 20,
    clientLoadingEnd: 100
};

export const PRELOADER_PERCENTS_PROD: PreloaderPercentsLayout = {
    initialPercent: 56,
    compilingEndPercent: 66,
    clientLoadingStart: 66,
    clientLoadingEnd: 100
};

export const PRELOADER_PERCENTS_COMPILE_ONLY_PROD: PreloaderPercentsLayout = {
    initialPercent: 0,
    compilingEndPercent: 100,
    clientLoadingStart: 100,
    clientLoadingEnd: 100
};

export const COMPATIBILITY_CHECK_FAILED_PERCENTS = -2;

export function getPreloaderPercentsLayout(): PreloaderPercentsLayout {
    const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
    if (ffLoader.get(FlagNames.SHOW_REAL_LOADING_PERCENTS).isOn()) {
        return PRELOADER_PERCENTS_REAL;
    }

    return PRELOADER_PERCENTS_PROD;
}
